export default {
  ad: "Annonce"
}
